import Constants from '../constants/RoutesConstants';
import RoutesRemoting from '../../remoting/RoutesRemoting';
import StatusCodes from '../../model/StatusCodes';

/**
 *
 * @param {*} type - type constant (string)
 * @param {*} data - object, list or string
 */
function dispatchToReducer (type, data) {
  return {
    type: type,
    data: data,
  };
}

/**
 * getRoutes called on client getting available routes
 */
export function getRoutes () {
  return dispatch => {
    dispatch(dispatchToReducer(Constants.ROUTES_REQUEST));
    RoutesRemoting.getRoutes()
      .then(response => {
        if (response && response.status === StatusCodes.UNKNOWN_ERROR) {
          return dispatch(dispatchToReducer(Constants.ROUTES_FAILURE, response));
        }
        if (response && response.status === StatusCodes.OK && response.data.length) {
          return dispatch(dispatchToReducer(Constants.ROUTES_SUCCESS, response.data));
        }
        return dispatch(dispatchToReducer(Constants.ROUTES_FAILURE, response));
      })
      .catch(error => {
        console.error('Error occured: ', error);
        return dispatch(dispatchToReducer(Constants.ROUTES_FAILURE, error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/RoutesActions.js